import React from 'react';
import Typography from '@material-ui/core/Typography';
import EarningStatistic from './EarningStatistic';
import {StatisticBox, ParagraphSkeleton} from '../../../../components';
import {useGetMessages} from '../../../../hooks';
import {Earnings} from '../../../../reducers/dashboard';
import {makeStyles} from '@material-ui/core';
import {getMessage} from 'epic-diesel-common';
import {dateFormatUTC} from '../../../../../shared/utils/DateUtils';

const useStyles = makeStyles(theme => ({
    withHoldings: {
        color: theme.palette.grey[700],
        padding: theme.spacing(4, 0),
        letterSpacing: '0.5px',
        textTransform: 'uppercase'
    }
}));

export interface MyEarningsProps {
    isRendering?: boolean;
    earnings: Earnings;
    i18nMessages: Record<string, string>;
}

const MyEarnings: React.FC<MyEarningsProps> = ({isRendering = false, i18nMessages, earnings}) => {
    const styles = useStyles();
    const messages = useGetMessages(() => {
        const fLastPayoutDate = dateFormatUTC(earnings.lastPayoutDate);
        return {
            lastPayoutTitle: 'epic.affiliate.earnings.my_earnings.title',
            lastPayoutSubtitle: {
                code: 'epic.affiliate.earnings.my_earnings.last_payment.subtitle.v2',
                args: [fLastPayoutDate || 'N/A']
            },
            lastPayoutTooltip: 'epic.affiliate.earnings.my_earnings.tooltip.last_payout.subtext',
            lifetimePayoutSubtitle:
                'epic.affiliate.earnings.my_earnings.total_earnings.subtitle.v2',
            withHoldings: {
                code: 'epic.affiliate.earnings.my_earnings.withholdings.v2',
                args: [
                    fLastPayoutDate ||
                        getMessage(i18nMessages, 'epic.affiliate.common.lastPaymentDate.v2')
                ]
            }
        };
    }, [earnings.lastPayoutDate]);

    return (
        <EarningStatistic
            isRendering={isRendering}
            title={messages.lastPayoutTitle}
            tipTitle={messages.lastPayoutTooltip}>
            <StatisticBox
                isRendering={isRendering}
                type="currency"
                header={earnings.lastPayout}
                subHeader={messages.lastPayoutSubtitle}
                CardHeaderProps={{titleTypographyProps: {variant: 'h2'}}}
            />
            <StatisticBox
                isRendering={isRendering}
                type="currency"
                header={earnings.lifetimePayouts}
                subHeader={messages.lifetimePayoutSubtitle}
                CardHeaderProps={{titleTypographyProps: {variant: 'h2'}}}
            />
            {isRendering ? (
                <ParagraphSkeleton />
            ) : (
                <Typography className={styles.withHoldings} variant="body2">
                    {messages.withHoldings}
                </Typography>
            )}
        </EarningStatistic>
    );
};

export default MyEarnings;
